import { css } from 'styled-components'

export const focusStyle = css`
  outline: 2px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  outline-offset: 2px;
`

export const focusStyleOffset = '4px'

export default focusStyle
